export default __webpack_public_path__ + "static/media/Lip_7_F.2a889d95.svg";